import { injectIntl } from 'react-intl';
import PendingRequest from './PendingRequest';
import config from './config';

export const CONFIG = config;

export default injectIntl(PendingRequest);
